<template>
  <div class="container p-4 w-full hidden-on-print bg-white rounded-lg mb-4">
    <div class="flex items-center gap-2 overflow-hidden">
      <LocalizedLink
        to="/"
        class="whitespace-nowrap text-dark hover:text-green transition-300 leading-140 text-base font-medium"
      >
        {{ $t("home") }}
      </LocalizedLink>

      <div
        v-for="(item, index) in menu"
        :key="index"
        class="flex items-center gap-1 sm:gap-2 group last:pr-1"
      >
        <i class="w-1 h-1 bg-gray rounded-full" />
        <LocalizedLink
          v-if="item.title"
          :to="`${item?.link}`"
          :class="{
            'pointer-events-none text-dark/40 font-normal !line-clamp-1 whitespace-pre-wrap':
              index === menu?.length - 1,
          }"
          class="transition-300 flex cursor-pointer items-center text-dark hover:text-green capitalize font-medium text-base leading-140 line-clamp-1 whitespace-nowrap"
        >
          {{ item?.title }}
        </LocalizedLink>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import LocalizedLink from "@/components/CLocalizedLink.vue";

interface Props {
  menu: {
    title: string;
    link: string;
  }[];
}

defineProps<Props>();
</script>

<style>
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}
</style>
